import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'ClickUp Case Study | Canny';
const Description =
  'Read about how ClickUp uses Canny to keep track of feedback from a rapidly growing user base.';
const Image = 'https://canny.io/images/helmet-clickup-case-study.jpg';
const ClickupUrl = 'https://canny.io/case-studies/clickup';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${ClickupUrl}#webpage`,
    url: ClickupUrl,
    name: 'Case Study: ClickUp × Canny',
    description:
      'How ClickUp uses Canny to keep track of feedback from a rapidly growing user base.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${ClickupUrl}#article`,
    genre: 'Case Study',
    headline: 'How ClickUp uses Canny to keep track of feedback from a rapidly growing user base',
    description:
      'In less than a year, over 3,500 ClickUp users submitted feedback more than 30,000 times using Canny. Feedback arrives from internal teams, email, and Intercom—with the ability to vote on behalf of customers. This streamlines cross-team communication and significantly reduces feedback management effort.',
    inLanguage: 'en',
    url: ClickupUrl,
    mainEntityOfPage: { '@id': `${ClickupUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'ClickUp', url: 'https://clickup.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'ClickUp', item: ClickupUrl },
  ]),
]);

export default class ClickupLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: ClickupUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
